import {Component, Inject} from '@angular/core';
import {User} from '../../model';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AutocompleteMixin} from './autocomplete.mixin';

@Component({
  template: `
    <h1 mat-dialog-title>{{title}}</h1>
    <mat-dialog-content>
      <mat-form-field appearance="fill" class="col-2_3">
        <mat-label>Mitarbeiter wählen</mat-label>
        <input name="extern" matInput [formControl]="autocomplete.formControl" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayEntry"
                          (optionSelected)="entry=$event.option.value">
          <mat-option *ngFor="let entry of autocomplete.entries | async" [value]="entry">
            <span style="display: inline-block; width: 5em">{{entry.login}}</span>
            {{entry.firstname}} {{entry.name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <button mat-raised-button color="primary" [mat-dialog-close]="entry" [disabled]="!entry">
        <mat-icon>done</mat-icon>
        Auswählen
      </button>
    </mat-dialog-content>
  `
})
export class UserSelectDialogComponent {
  title: string;
  entry: User;
  autocomplete: AutocompleteMixin<User>;

  constructor(@Inject(MAT_DIALOG_DATA) {title, entries}: any) {
    this.title = title;
    this.autocomplete = new AutocompleteMixin(
      entries,
      (entry, search) =>
        entry.name?.toLowerCase().includes(search) ||
        entry.login?.toLowerCase().includes(search) ||
        entry.firstname?.toLowerCase().includes(search)
    );
  }

  displayEntry(entry: User): string {
    return entry ? (entry.login + ' / ' + entry.firstname + ' ' + entry.name).trim() : '';
  }
}
